import React from 'react';
import classnames from 'classnames';
class ScrollToTop extends React.Component {
    constructor(props) {
        super(props);
        this.onScroll = () => {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.setState({
                    show: window.scrollY > this.props.scrollDuration,
                });
            }, 100);
        };
        this.scrollToTop = () => {
            function checkElement() {
                // chrome,safari及一些浏览器对于documentElemnt的计算标准化,reset的作用
                document.documentElement.scrollTop += 1;
                let elm = document.documentElement.scrollTop !== 0 ? document.documentElement : document.body;
                document.documentElement.scrollTop -= 1;
                return elm;
            }
            const { to: lastPosition } = this.props; // 最终滚动到位置
            let element = checkElement();
            let start = element.scrollTop; // 当前滚动距离
            const duration = start - lastPosition;
            let count = 0;
            let speed = 0.05;
            function scroll() {
                count++;
                speed += 0.01; // 逐渐加速
                element.scrollTop = start - duration * count * speed;
                if ((element.scrollTop - lastPosition) * duration <= 0) {
                    element.scrollTop = lastPosition;
                    return;
                }
                if (window.requestAnimationFrame) {
                    window.requestAnimationFrame(scroll);
                }
                else {
                    window.scrollTo(0, lastPosition);
                }
            }
            scroll();
        };
        this.renderTopIcon = () => {
            return <div></div>;
        };
        this.state = {
            show: false,
        };
    }
    componentDidMount() {
        window.addEventListener('scroll', this.onScroll);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll);
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
    render() {
        const { scrollIcon, style = {}, className } = this.props;
        const { show } = this.state;
        const scrollCls = classnames('cfm_scroll_top', {
            'cfm_scroll_top_show': show,
        }, className);
        const scrollStyle = Object.assign({}, style);
        return <div style={{ height: 0 }}>
      <a className={scrollCls} style={scrollStyle} onClick={this.scrollToTop}>
        {scrollIcon ? scrollIcon : <div className='cfm_scroll_top_icon'></div>}
      </a>
    </div>;
    }
}
ScrollToTop.defaultProps = {
    to: 0,
    scrollDuration: 300,
};
export default ScrollToTop;



// WEBPACK FOOTER //
// ./components/scroll-to-top/index.tsx